import { readonly, ref } from "vue";

import { type UpdateServiceWorker, registerPwaServiceWorker } from "@/lib/pwa-registration";

const needRefresh = ref(false);
const offlineReady = ref(false);
let initialized = false;
let updateServiceWorker: UpdateServiceWorker | null = null;

const initializePwaUpdate = () => {
  if (initialized || typeof window === "undefined") return;

  initialized = true;
  void registerPwaServiceWorker({
    onNeedRefresh() {
      needRefresh.value = true;
    },
    onOfflineReady() {
      offlineReady.value = true;
    },
    onRegisterError(error) {
      console.error("Service worker registration failed:", error);
    },
  })
    .then((register) => {
      updateServiceWorker = register;
    })
    .catch((error) => {
      console.warn("Service worker registration unavailable:", error);
    });
};

const dismissUpdate = () => {
  needRefresh.value = false;
};

const dismissOffline = () => {
  offlineReady.value = false;
};

const updateNow = async () => {
  needRefresh.value = false;
  await updateServiceWorker?.(true);
};

export const usePwaUpdate = () => {
  initializePwaUpdate();

  return {
    needRefresh: readonly(needRefresh),
    offlineReady: readonly(offlineReady),
    updateNow,
    dismissUpdate,
    dismissOffline,
  };
};
